import Item from 'common/ITEMS/Item';

const items = {} satisfies Record<string, Item>;

export default items;
